import { useEffect } from 'react';
import { useSocketStore } from '../../stores/useSocketStore';
import { useSchedulesStore } from '../../stores/useSchedulesStore';

export function useEnsureSchedule(redisKey) {

    const socket = useSocketStore(state => state.socket);

    useEffect(() => {

        if (!socket || !redisKey) {
            return;
        }

        const {
            schedules,
            setSchedule
        } = useSchedulesStore.getState();

        if (redisKey in schedules) {
            return;
        }

        socket.emit(
            'schedule:get',
            redisKey,
            response => {

                setSchedule(
                    response?.data || {}
                );

            }
        );

    }, [socket, redisKey]);

}